module.exports = __webpack_public_path__ + "static/media/add_circle.901740e5.svg";